module.exports = __webpack_public_path__ + "cc56dcf608370c92ed34e0c2c22f4b1c.fbx";